import {
  SAVE_INTEGRATION_SETTINGS,
  SAVE_INTEGRATION_SETTINGS_ERROR,
  SAVED_INTEGRATION_SETTINGS
} from 'actions'
import createApiMiddlewareReducer from './utils/create-api-middleware-reducer'

const settingsReducer = createApiMiddlewareReducer({
  request: SAVE_INTEGRATION_SETTINGS,
  failure: SAVE_INTEGRATION_SETTINGS_ERROR,
  receive: SAVED_INTEGRATION_SETTINGS
})

export default function (state = {}, { type, payload = {} }) {
  if (payload === null) return state
  switch (type) {
    case SAVE_INTEGRATION_SETTINGS:
    case SAVE_INTEGRATION_SETTINGS_ERROR:
    case SAVED_INTEGRATION_SETTINGS:
      const { workspaceSlug, projectSlug, integrationName } = payload
      const key = `${workspaceSlug}-${projectSlug}-${integrationName}`
      return {
        ...state,
        [key]: settingsReducer(state[key], { type, payload })
      }
    default:
      return state
  }
}



// WEBPACK FOOTER //
// ./reducers/integration-settings.js